module.exports = __webpack_public_path__ + "static/media/header1.8288f4e7.jpg";